import { Trans, useTranslation } from 'react-i18next';
import { Col, Image, Row } from "react-bootstrap";
import PageLayout from './PageLayout';

function About() {
    const { t } = useTranslation('messages');

    return (
        <PageLayout
            hero={<h1 className="display-5 fw-bold mb-0">{t('main.about.title')}</h1>}
            heroCenter
            mainPadding="py-5"
        >
            <Row className="align-items-center g-5 justify-content-center">
                <Col xs={12} sm={6} md={4} className="text-center">
                    <Image
                        src="./images/profile.jpg"
                        alt={t('main.about.profile_image_alt_text')}
                        roundedCircle
                        className="shadow"
                        style={{ width: 200, height: 200, objectFit: 'cover' }}
                    />
                </Col>
                <Col xs={12} md={7}>
                    <div className="text-secondary lh-lg">
                        <Trans i18nKey='main.about.description' ns='messages' />
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}

export default About;
